<template>
  <BaseDialog
    :isOpen="isOpen"
    :width="1200"
    :fullscreen="isMobile"
    @close="close"
  >
    <template v-slot:title>
      Edit Qualification
    </template>
    <template v-slot:body>
      <QualificationDetailsForm
        :class="{ container: isMobile }"
        ref="qualificationDetailsForm"
        :initialData="qualification"
      />
    </template>
    <template v-slot:actions>
      <PrimaryButton
        @click.native="close"
        text
        :disabled="isLoading"
        v-if="!isMobile"
      >
        Cancel
      </PrimaryButton>
      <PrimaryButton @click.native="onSubmit" :loading="isLoading">
        Save Changes
      </PrimaryButton>
    </template>
  </BaseDialog>
</template>

<script>
import BaseDialog from "@/components/common/BaseDialog";
import PrimaryButton from "@/components/common/Button/PrimaryButton";
import QualificationDetailsForm from "@/views/profile/QuestionsAndAnswers/steps/Qualifications/components/QualificationDetailsForm";
import { createNamespacedHelpers } from "vuex";
import { QUALIFICATIONS_NAMESPACE } from "@/store/modules/users/qualifications";
import { EDIT_USER_QUALIFICATION } from "@/store/modules/users/qualifications/actions";
import { BASE_DATE_FORMAT, API_DATE_FORMAT } from "@/constants/common";
import { formatDate } from "@/utils/time";

const { mapActions } = createNamespacedHelpers(QUALIFICATIONS_NAMESPACE);

export default {
  name: "EditQualificationDialog",
  components: {
    PrimaryButton,
    BaseDialog,
    QualificationDetailsForm
  },
  props: {
    qualification: Object,
    isOpen: Boolean
  },
  data() {
    return {
      isLoading: false
    };
  },
  methods: {
    ...mapActions({
      editUserQualification: EDIT_USER_QUALIFICATION
    }),
    close() {
      this.$emit("close");
    },
    async onSubmit() {
      const isValid = await this.$refs.qualificationDetailsForm.validate();
      if (isValid) {
        const qualificationData = this.$refs.qualificationDetailsForm.getData();
        this.isLoading = true;
        await this.editUserQualification({
          ...qualificationData,
          dateStarted: formatDate({
            date: qualificationData.dateStarted,
            startFormat: BASE_DATE_FORMAT,
            endFormat: API_DATE_FORMAT
          }),
          dateCompleted: formatDate({
            date: qualificationData.dateCompleted,
            startFormat: BASE_DATE_FORMAT,
            endFormat: API_DATE_FORMAT
          })
        });
        this.close();
        this.isLoading = false;
      }
    }
  }
};
</script>

<style lang="scss"></style>
